import styled, { css } from 'styled-components';
import { ISelectableEventItemStyledProps } from './bind-modal-content.types';

export const BindModalContentStyled = styled.div`
  min-width: 500px;
  width: 1000px;
`;

export const NotFoundContent = styled.div`
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray[50]};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -6px;
  height: 48px;
  padding: 8px;
  border-radius: 12px;
  box-sizing: border-box;
`;

export const SelectableEventItemStyled = styled.div<ISelectableEventItemStyledProps>`
  ${({ $isSelectable, $isChecked, theme }) => css`
    --event-item-bg: ${!$isSelectable ? theme.colors.gray[5] : $isChecked ? theme.colors.blue[5] : theme.colors.gray[0]};
    --event-item-cursor: ${!$isSelectable ? 'not-allowed' : 'pointer'};
  `}

  display: grid;
  grid-template-columns: 16px 1fr auto;
  padding: 8px 16px;
  grid-column-gap: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  user-select: none;
  color: ${({ theme }) => theme.colors.gray[70]};
  background-color: var(--event-item-bg);
  cursor: var(--event-item-cursor);

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors.gray[10]};
  }

  .live-status {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 12px;
    height: 12px;
    background-color: ${({ theme }) => theme.colors.red[50]}1A;
    padding: 5px;
    border-radius: 50%;
    box-sizing: border-box;
    margin-top: 2px;

    &:before {
      content: '';
      display: block;
      flex-shrink: 0;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.red[50]};
    }
  }
`;

export const SelectableEventListStyled = styled.div`
  max-height: 180px;
  overflow-y: auto;

  .item {

  }
`;

export const SelectAllStyled = styled.div`
  display: flex;
  justify-content: end;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray[40]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[10]};

  label {
    cursor: pointer;
  }
`;
